import { DateTime } from 'luxon';

export const dateTimeToDate = (dateTime: string) => {
  return DateTime.fromISO(dateTime).toFormat('yyyy-MM-dd');
};
